module.exports = __webpack_public_path__ + "media/images/vision/board_bg-dfff10a0a96076c25d4fd8526e95b38e.png";